module.exports = "## Snackbar\n\n[Snackbars](https://www.google.com/design/spec/components/snackbars-toasts.html) provide lightweight feedback about an operation by showing a brief message at the bottom of the screen. Snackbars can contain an action.\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Snackbar/README.md
 ** module id = 1055
 ** module chunks = 0
 **/